import { withInstall } from '@ll-plus/utils'

import Modal from './src/modal.vue'

export const LlNewModal = withInstall(Modal)
export default LlNewModal
export * from './src/modal'

declare module 'vue' {
  export interface GlobalComponents {
    LlNewModal: typeof Modal
  }
}
